import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const fieldDisplayTextValidatorSchema = {
    label: displayTextLabelValidator,
    placeholder: Validator.optional(nonEmptyStringValidator),
    requiredMessage: nonEmptyStringValidator,
    formatMessage: Validator.optional(nonEmptyStringValidator),
    lengthMessage: Validator.optional(nonEmptyStringValidator)
};
